import { Schema as S } from "effect";

/**
 * Response after booking an appointment.
 * @since 1.1.8
 * @example BookAppointmentResponseSchema;
 */
export const BookAppointmentResponseSchema = S.Struct({
  /** Created schedule ID */
  scheduleId: S.String,
  /** Appointment start time */
  startTime: S.String,
  /** Appointment end time */
  endTime: S.String,
  /**
   * True when this response replays an earlier booking with the same
   * `clientSubmissionId` instead of creating a new appointment.
   *
   * The patient sees the same confirmed appointment either way; the flag
   * exists so callers and evidence can tell a replay from a fresh booking.
   */
  replayed: S.optional(S.Boolean),
});

/** Shared scheduling contract for BookAppointmentResponse.
 * @since 1.1.8
 * @example BookAppointmentResponse;
 */
export type BookAppointmentResponse = S.Schema.Type<
  typeof BookAppointmentResponseSchema
>;

